import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sqChecklistApi = createApi({
  baseQuery,
  reducerPath: 'sqChecklistApi',
  endpoints: builder => ({
    getChecklistData: builder.query<any, any>({
      query: ({ monitoring_visit_id, site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Checklist.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?monitoring_visit_id=${monitoring_visit_id}&country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createChecklist: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Checklist.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateChecklist: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Checklist.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getChecklistPILData: builder.query<any, any>({
      query: ({ monitoring_visit_id, site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Checklist.selectPIL,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?monitoring_visit_id=${monitoring_visit_id}&country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createChecklistPIL: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Checklist.createPIL,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateChecklistPIL: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Checklist.updatePIL,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAllSQChecklists: builder.mutation<any, any>({
      query: ({data,site_id, study_id, country, application, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.Checklist.getAll
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body:data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAllPILSQChecklists: builder.mutation<any, any>({
      query: ({data, site_id, study_id, country, application, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.Checklist.getAllPIL
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body:data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishSQChecklistEtmf: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        publish_doc_version,
        is_published,
        monitoring_visit_id,
        update,
        application,
        application_section
      }) => ({
        url: `${formatString(
          endPoints.Checklist.pulishEtmf,
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id }
        )}?country=${country}&publish_doc_version=${publish_doc_version}&monitoring_visit_id=${monitoring_visit_id}&is_published=${is_published}&update=${update}&application=${application}&application_section=${application_section}`,
        method: 'POST',
        body: {}
      })
    })
  })
});

export const {
  useGetChecklistDataQuery,
  useLazyGetChecklistDataQuery,
  useCreateChecklistMutation,
  useUpdateChecklistMutation,
  useGetChecklistPILDataQuery,
  useLazyGetChecklistPILDataQuery,
  useCreateChecklistPILMutation,
  useUpdateChecklistPILMutation,
  useGetAllSQChecklistsMutation,
  useGetAllPILSQChecklistsMutation,
  usePublishSQChecklistEtmfMutation
} = sqChecklistApi;
